import { useState } from "react";
import ConfirmAlertModal from "../../Modals/confirmAlertModal";
import { Action } from "../../utility/common/constants/CommonConstants";

import { DeletePQRProcess } from "../../../Services/pqr-details-service";
import { createDetailObjPQR } from "./PQR_common";
import { ProcessTypeTable } from "../../utility/common/TransactionComponents/ProcessTypeTable";
import { showToast } from "../../utility/ui/navigation/TransactionNavigation/TransactionUtils";
import { MessageTypes } from "../../utility/common/constants/CommonConstants";

export const PQRProcess = ({
  headerObj,
  detailObj,
  setdetailObj,
  ProcessActive,
  isReadonly,
  disabled,
  handleProcessCheckboxChange,
  action,
  setIsEdited,
}) => {
  const [show, setShow] = useState(false);
  const [processdelete, setprocessDelete] = useState(99);
  const formName = "PQR Process";

  const processDelete = async () => {
    setShow(false);
    if (detailObj[processdelete].PK != "") {
      try {
        DeletePQRProcess(
          detailObj[processdelete].PK,
          detailObj[processdelete].SK
        );
        showToast(MessageTypes.ProcessDeleted);

        let newdet = detailObj.filter((det, i) => i !== processdelete);
        let temparray1 = createDetailObjPQR(4, 4);
        setdetailObj([...newdet, ...temparray1]);
      } catch (ex) {
        console.error("Error deleting PQR process:", ex);
        showToast(MessageTypes.ProcessDeleteFailed);
      }
    }
  };

  const handleProcessChange = (value, index, item) => {
    if (value === "NA") {
      setShow(true);
      setprocessDelete(index);
    }
  };

  const handleProcessCheckboxChangeLocal = (processIndex, checked) => {
    if (handleProcessCheckboxChange) {
      handleProcessCheckboxChange(processIndex, checked);
    }
  };

  return (
    <>
      <div style={{ position: "relative", bottom: "8px" }}>
        <ProcessTypeTable
          detailObj={detailObj}
          setdetailObj={setdetailObj}
          ProcessActive={ProcessActive}
          fieldPrefix="PQR"
          showLayer={headerObj?.wld_WPSType === "Overlay"}
          onProcessChange={handleProcessChange}
          isReadonly={isReadonly}
          className="PQRSelect"
          disableFields={disabled}
          handleProcessCheckboxChange={handleProcessCheckboxChangeLocal}
        />
      </div>
      <ConfirmAlertModal
        handleYes={processDelete}
        formName={formName}
        action="Delete"
        show={show}
        handleClose={() => setShow(false)}
      />
    </>
  );
};
